<template>
    <pm-custom-dialog v-model="visible">


        <div style="background: url(/images/onboarding/onboarding-plan2.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;"></div>

        <div style="margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Subscribe now</h2>
            <span style="font-weight: 600;">and keep using the best of DentiCalc</span>
        </div>

        <div style="padding: 0 20px; text-align: left;">

            <div style="display: flex; justify-content: center; align-items: center;">
                <div style="line-height: 2.5;">

                <mdi size="22" style="margin-right: 5px; color: #777;">mdiToothOutline</mdi> SMART plan tool<br/>

                <mdi size="22" style="margin-right: 5px; color: #777;">mdiPlayBoxOutline</mdi> Access to all videos<br/>

                <mdi size="22" style="margin-right: 5px; color: #777;">mdiContentSaveOutline</mdi> Save plan / History<br/>

                <mdi size="22" style="margin-right: 5px; color: #777;">mdiEmailSendOutline</mdi> Send plan and animation<br/>

                <mdi size="22" style="margin-right: 5px; color: #777;">mdiPrinter</mdi> Print plan to PDF<br/>

                </div>
            </div>

            <br/>

            <div style="display: flex; justify-content: center; align-items: center;">

                <div @click="subscribe" style="width: 200px; justify-content: center; align-items:center; font-size: 16px; letter-spacing: -0.5px; display: flex; background: #ffaa07; color: #fff; padding: 8px 8px 8px 24px; margin: 0 10px; border-radius: 20px;">
                    <template v-show="!isProcessing">
                        <div style="flex-grow: 0; line-height: 1; font-weight: 600;">
                            CONTINUE<br><small>{{ price }}/month</small>
                        </div>
                        <mdi style="margin-left: 10px; color: #fff; ">mdiChevronRight</mdi>
                    </template>
                    <div v-show="isProcessing">
                        Redirecting to
                        <template v-if="$isIOS()">the App Store</template>
                        <template v-else>Google Play</template>...
                    </div>
                </div>
            </div>

            <div style="line-height: 1.2; font-size: 11px; padding: 20px 28px 16px 28px; text-align: center;" class="trial-more-info--message">
                <span>
                    <span style="font-weight: 600;">Cancel anytime</span> in the Store.
                    <pm-privacy-links @click="visible = false" />
                </span>
            </div>
        </div>

    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { getProductPrices } from "../../utils/iap/product-price";
import PmPrivacyLinks from "../addons/privacy-links";
export default {
    components: {
        PmCustomDialog,
        PmPrivacyLinks,
    },
    data: () => ({
        visible: false,
        sku: "",
        isProcessing: false,
        price: "",
    }),
    created() {
        this.$bus.$on('extra-features-dialog:show', () => {
            this.show();
        });

        this.registerBusEvent('subscribe:process', (data) => {
            this.isProcessing = Boolean(data);
        });
        this.registerBusEvent('subscribe:cancelled', () => {
            this.isProcessing = false;
        });
    },
    methods: {
        show() {
            this.sku = "cloud_save_and_email_send_monthly_sku";
            this.price = getProductPrices(window.IAP.products[this.sku]);
            this.visible = true;
        },
        subscribe() {
            this.isProcessing = true;

            window.IAP.subscribe(this.sku);

            window.Tracker.logEvent({
                event_name: "subscribe_inited",
                event_category: "in_app_payment",
                event_label: this.sku,
            });
        },
    }
}
</script>
